export const formatScenicSpotList = (list = []) => {
  return list.map(f => ({
    label: f?.name,
    value: f?.id,
    cover: f?.latestCase?.coverPath ?? f?.defaultCoverPath
  }))
}
